<div class="banner d-none d-lg-flex" role="banner">
  <h1>{{ 'games.banner.title' | translate }}</h1>
</div>
<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>

<div class="container mt-3">
  <div class="game-container-sections">
    <div>
      @if (isKid) {
      <img src="assets/images/games/Jr_Tile-Trivia.jpg" />
      } @else if (isMember) {
      <img src="assets/images/games/TriviaBanner.jpg" />
      } @else if (isClub1901) {
      <img src="assets/images/games/1901-trivia.jpg" />
      }
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.trivia' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.trivia.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/trivia'">
          <div class="btn btn-primary">{{ 'games.page.trivia.play' | translate }}</div>
        </div>
      </div>
    </div>

    <div>
      @if (isKid) {
      <img src="assets/images/games/Jr_Tile-Predictor.jpg" />
      } @else if (isMember) {
      <img src="assets/images/games/PredictorBanner.jpg" />
      } @else if (isClub1901) {
      <img src="assets/images/games/1901-predictor.jpg" />
      }

      <div class="card">
        <div class="">
          <h5>{{ 'games.page.predictor' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.predictor.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/predictor'">
          <div class="btn btn-primary">{{ 'games.page.predictor.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="game-container-sections mt-4">
    <div>
      @if (isKid) {
      <img src="assets/images/games/Jr_Tile-Polls.jpg" />
      } @else if (isMember) {
      <img src="assets/images/games/PollsBanner.jpg" />
      } @else if (isClub1901) {
      <img src="assets/images/games/1901-polls.jpg" />
      }

      <div class="card">
        <div class="">
          <h5>{{ 'games.page.polls' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.polls.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/polls'">
          <div class="btn btn-primary">{{ 'games.page.polls.play' | translate }}</div>
        </div>
      </div>
    </div>

    @if (!isMemberKid) {
    <div>
      @if (isSTH || isClub1901) {
      <img src="assets/images/games/PaPMember.jpg" />
      } @else if (isAdultMember) {
      <img src="assets/images/games/PaPSTH.jpg" />
      } @else if (isSTHKid) {
      <img src="assets/images/games/PaPKids.jpg" />
      } @else {
      <img src="assets/images/games/PaPSTH.jpg" />
      }

      <div class="card">
        <div class="">
          <h5>{{ 'games.page.pap' | translate }}</h5>
          @if (isSTH || isSTHKid || isClub1901) {
          <div class="font-size-14">{{ 'games.page.pap.description' | translate }}</div>
          } @else {
          <div class="font-size-14">{{ 'games.page.pap.upgrade.description' | translate }}</div>
          }
        </div>
        <div (click)="navigateToPaP()">
          @if (isSTH || isSTHKid || isClub1901) {
          <div class="btn btn-primary">{{ 'games.page.pap.play' | translate }}</div>
          } @else {
          <div class="btn btn-primary">{{ 'games.page.pap.upgrade.play' | translate }}</div>
          }
        </div>
      </div>
    </div>
    } @if (isMemberKid) {
    <div>
      @if (isKid) {
      <img src="assets/images/games/Jr_Tile-Arcade.jpg" />
      } @else if (isMember) {
      <img src="assets/images/games/ArcadeBanner.jpg" />
      } @else if (isClub1901) {
      <img src="assets/images/games/1901-arcade.jpg" />
      }

      <div class="card">
        <div class="">
          <h5>{{ 'games.page.arcade' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.arcade.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/arcade'">
          <div class="btn btn-primary">{{ 'games.page.arcade.play' | translate }}</div>
        </div>
      </div>
    </div>
    }
  </div>

  @if (!isMemberKid) {

  <div class="game-container-sections mt-4">
    <div>
      @if (isKid) {
      <img src="assets/images/games/Jr_Tile-Arcade.jpg" />
      } @else if (isMember) {
      <img src="assets/images/games/ArcadeBanner.jpg" />
      } @else if (isClub1901) {
      <img src="assets/images/games/1901-arcade.jpg" />
      }

      <div class="card">
        <div class="">
          <h5>{{ 'games.page.arcade' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.arcade.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/arcade'">
          <div class="btn btn-primary">{{ 'games.page.arcade.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
